import { observer } from 'mobx-react-lite'
import React from 'react'
import { type ITextFieldProps, makeTextFieldError, TextFieldPlaceholder } from 'shared/ui/TextField'
import { EnrollmentPreview } from 'widgets/ContactEnrollment/ui/EnrollmentList'
import styles from './styles.module.scss'
import { type IEnrolmentStepProps } from './EnrolmentStep'

export type IEnrolmentStepTextFieldProps = Pick<
  IEnrolmentStepProps,
  'enrollmentFilters' | 'error' | 'onClick' | 'errorPlacement'
> & {
  size?: ITextFieldProps['size']
  variant?: ITextFieldProps['variant']
}

export const EnrolmentStepTextField = observer(
  ({
    enrollmentFilters,
    error,
    onClick,
    errorPlacement = 'bottom',
    size = 'small',
    variant = 'outline',
  }: IEnrolmentStepTextFieldProps) => {
    return (
      <TextFieldPlaceholder
        className={styles.placeholder}
        variant={variant}
        size={size}
        onClick={onClick}
        placeholder={
          <div className={styles.preview}>
            {!!enrollmentFilters.allSize ? (
              <EnrollmentPreview filters={enrollmentFilters} />
            ) : (
              'Enroll contacts (optional)'
            )}
          </div>
        }
        rightActions={[
          makeTextFieldError({
            placement: errorPlacement,
            anchor: 'container',
            offset: [0, 0],
          }),
        ]}
        error={error}
      />
    )
  }
)
